/* Etozil: bundelkeuze op de productpagina. Gebouwd door build.mjs (tools/etozil-theme), hier niet met de hand wijzigen.
   Ronde 10 (25-10): 1-op-1 de Kaching-bundel van Noirski (zelfde opbouw, maten en gedrag), alleen kleur en letter van Etozil.
   - Twee balken: "Pojedyncze - 1x" en "Podwójne - 2x" (-10%, flapje "Najlepsza wartość").
   - Alleen de gekozen balk toont zijn stukken: één regel per stuk met foto, kleur (eigen keuzelijst) en maat (gewone keuzelijst).
     Balk 1 heeft één regel, balk 2 twee. Geen nummers, geen kleurbolletjes, geen extra regels.
   - Gedrag zoals Noirski: verandert de gewone kleur/maat bovenaan, dan volgen alle stukken; verandert een stuk, dan volgt de gewone
     keuze bovenaan dat stuk; een andere balk kiezen zet de gewone keuze op het eerste stuk van die balk.
   - De korting rekent Shopify (automatische korting "2 szt. −10%" op de hele bestelling); dit script toont alleen dezelfde som.
   Het thema tekent het blok opnieuw bij elke variantkeuze; de keuze per balk blijft daarom in window.__etBun staan. */
(function () {
  if (window.__etBunLoaded) return; window.__etBunLoaded = true;
  var STATE = (window.__etBun = window.__etBun || {});
  var FORM_RE = /^product-form-main-(\d+)-/;
  var PCT = 10;                       // balk 2: -10% (zelfde als de automatische korting "2 szt.")
  var COUNT = { 1: 1, 2: 2 };         // stuks per balk
  var uid = 0;

  function fmt(cents, f) {
    f = f || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || "{{amount_with_comma_separator}} zł";
    function digits(n, p, t, d) {
      p = p == null ? 2 : p; t = t == null ? "," : t; d = d == null ? "." : d;
      var s = (n / 100).toFixed(p).split("."), a = s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + t), b = s[1] ? d + s[1] : "";
      return a + b;
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case "amount": return digits(cents);
        case "amount_no_decimals": return digits(cents, 0);
        case "amount_with_comma_separator": return digits(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return digits(cents, 0, ".", ",");
        case "amount_with_space_separator": return digits(cents, 2, " ", ",");
        case "amount_no_decimals_with_space_separator": return digits(cents, 0, " ", ",");
        case "amount_with_apostrophe_separator": return digits(cents, 2, "'", ".");
        default: return digits(cents);
      }
    });
  }
  // in de balken zoals Noirski: hele bedragen zonder ",00" (229 zł), anders met centen (286,20 zł); = Liquid money_without_trailing_zeros
  function fmtBar(cents) { var s = fmt(cents); return cents % 100 === 0 ? s.replace(/[.,]00(?!\d)/, "") : s; }
  // dezelfde afronding als de Liquid in het blok: hele centen, halven omhoog
  var pctOf = function (c) { return Math.floor((c * (100 - PCT) + 50) / 100); };
  function totals(vs) {
    var sum = 0, cmp = 0;
    vs.forEach(function (v) { if (!v) return; sum += v.p; cmp += v.c > v.p ? v.c : v.p; });
    return { pay: pctOf(sum), was: cmp, raw: sum };
  }
  function fire(el, name, detail) { el.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); }
  function mk(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  var COLOR_RE = /kolor|color|colour|farbe|couleur|colore|färg|farve/i;

  // één open kleurlijst tegelijk; klik ernaast of Escape sluit hem
  var openDd = null;
  function closeDd(focus) {
    if (!openDd) return; var d = openDd; openDd = null;
    d.list.hidden = true; d.trig.setAttribute("aria-expanded", "false"); d.wrap.classList.remove("is-open");
    if (focus) d.trig.focus();
  }
  document.addEventListener("pointerdown", function (e) { if (openDd && !openDd.wrap.contains(e.target)) closeDd(false); }, true);

  customElements.define("et-bundle", class extends HTMLElement {
    connectedCallback() {
      var self = this, pid = (this.pid = this.dataset.pid);
      var json = function (s) { try { return JSON.parse(this.querySelector(s).textContent); } catch (e) { return null; } }.bind(this);
      this.V = json("script[data-v]") || []; this.O = json("script[data-o]") || [];
      this.byId = {}; this.V.forEach(function (v) { self.byId[v.id] = v; });
      this.multi = this.O.length > 0;
      var cur = this.byId[+this.dataset.vid], first = cur || this.V.find(function (v) { return v.a; }) || {};
      var st = STATE[pid];
      if (!st) st = STATE[pid] = { bar: 1, rows: { 1: [], 2: [] }, main: null, sent: [] };
      if (cur) {
        var echo = st.sent.indexOf(cur.id);
        if (echo >= 0) st.sent.splice(echo, 1);                      // ons eigen verzoek komt terug: stukken laten zoals ze zijn
        else if (st.main !== cur.id) { st.rows[1] = [cur.id]; st.rows[2] = [cur.id, cur.id]; }   // gewone keuze veranderd: alle stukken volgen
        st.main = cur.id;
      }
      [1, 2].forEach(function (b) {
        for (var i = 0; i < COUNT[b]; i++) { var v = self.byId[st.rows[b][i]]; if (!v || !v.a) st.rows[b][i] = first.id; }
        st.rows[b].length = COUNT[b];
      });
      this.st = st;
      this.querySelectorAll(".et-bn__bar").forEach(function (bar) {
        var b = +bar.dataset.bar, r = bar.querySelector(".et-bn__in");
        if (r) r.addEventListener("change", function () { if (r.checked) self.selectBar(b); });
        bar.addEventListener("click", function (e) { if (st.bar !== b && !e.target.closest(".et-bn__vars")) self.selectBar(b); });
      });
      this.render();
      fire(document, "et-bundle:change", { pid: pid });
    }
    disconnectedCallback() { if (openDd && this.contains(openDd.wrap)) openDd = null; }
    selectBar(b) {
      var st = this.st; if (st.bar === b) return;
      closeDd(false);
      st.bar = b;
      var v = this.byId[st.rows[b][0]];
      if (v && v.id !== st.main) this.followPicker(v);
      this.render(); fire(document, "et-bundle:change", { pid: this.pid });
    }
    // waarden van optie k die een beschikbare variant hebben, gegeven de gekozen waarden ervoor (eerst kleur, dan maat)
    allowed(sel, k) {
      var out = [];
      this.V.forEach(function (v) {
        if (!v.a) return;
        for (var j = 0; j < k; j++) if (v.o[j] !== sel[j]) return;
        if (out.indexOf(v.o[k]) < 0) out.push(v.o[k]);
      });
      return out;
    }
    pick(sel) { return this.V.find(function (v) { return v.a && v.o.every(function (x, i) { return x === sel[i]; }); }); }
    render() {
      var self = this, st = this.st;
      this.querySelectorAll(".et-bn__bar").forEach(function (bar) {
        var b = +bar.dataset.bar, on = b === st.bar, r = bar.querySelector(".et-bn__in");
        bar.classList.toggle("is-on", on); if (r) r.checked = on;
        var vs = st.rows[b].map(function (id) { return self.byId[id]; });
        var pr = bar.querySelector(".et-bn__price"), fu = bar.querySelector(".et-bn__full");
        if (b === 1 && vs[0]) { if (pr) pr.textContent = fmtBar(vs[0].p); if (fu) { fu.hidden = !(vs[0].c > vs[0].p); fu.textContent = fmtBar(vs[0].c); } }
        if (b === 2) { var t = totals(vs); if (t.raw) { if (pr) pr.textContent = fmtBar(t.pay); if (fu) { fu.hidden = false; fu.textContent = fmtBar(t.was); } } }
        var box = bar.querySelector(".et-bn__vars"), rows = box && box.querySelector(".et-bn__rows");
        if (!box) return;
        box.hidden = !(on && self.multi);
        if (rows) { rows.textContent = ""; if (on && self.multi) vs.forEach(function (v, i) { rows.appendChild(self.row(b, i, v)); }); }
      });
    }
    row(b, i, v) {
      var self = this, el = mk("div", "et-bn__row");
      var src = (v && v.img) || this.dataset.img;
      if (src) { var im = mk("img", "et-bn__img"); im.src = src; im.alt = ""; im.width = 40; im.height = 40; el.appendChild(im); }
      var sels = mk("div", "et-bn__sels"); el.appendChild(sels);
      var sel = v ? v.o.slice() : [];
      this.O.forEach(function (o, k) {
        var ok = self.allowed(sel, k);
        if (COLOR_RE.test(o.n)) sels.appendChild(self.dd(b, i, k, o, sel[k], ok));
        else {
          var s = mk("select", "et-bn__sel"); s.setAttribute("aria-label", o.n);
          o.v.forEach(function (name) {
            var op = mk("option", null, name); op.value = name;
            if (ok.indexOf(name) < 0 && name !== sel[k]) op.disabled = true;
            if (name === sel[k]) op.selected = true;
            s.appendChild(op);
          });
          s.addEventListener("change", function () { self.choose(b, i, k, s.value); });
          sels.appendChild(s);
        }
      });
      return el;
    }
    // kleur: een eigen keuzelijst met alleen de namen (zoals Noirski: geen bolletjes, geen foto in de lijst)
    dd(b, i, k, o, val, ok) {
      var self = this, id = "et-bn-l" + (++uid);
      var wrap = mk("span", "et-bn__dd");
      var trig = mk("span", "et-bn__sel et-bn__trig"); trig.appendChild(mk("span", null, val));
      trig.setAttribute("role", "combobox"); trig.tabIndex = 0; trig.setAttribute("aria-label", o.n);
      trig.setAttribute("aria-haspopup", "listbox"); trig.setAttribute("aria-expanded", "false"); trig.setAttribute("aria-controls", id);
      var list = mk("span", "et-bn__list"); list.id = id; list.setAttribute("role", "listbox"); list.setAttribute("aria-label", o.n); list.hidden = true;
      var opts = o.v.map(function (name) {
        var op = mk("span", "et-bn__opt", name); op.setAttribute("role", "option"); op.dataset.v = name;
        op.setAttribute("aria-selected", name === val ? "true" : "false");
        if (ok.indexOf(name) < 0 && name !== val) op.setAttribute("aria-disabled", "true");
        op.addEventListener("click", function (e) {
          e.stopPropagation(); if (op.getAttribute("aria-disabled") === "true") return;
          closeDd(true); if (name !== val) self.choose(b, i, k, name);
        });
        list.appendChild(op); return op;
      });
      wrap.appendChild(trig); wrap.appendChild(list);
      var d = { wrap: wrap, trig: trig, list: list }, act = -1;
      var setAct = function (n) {
        opts.forEach(function (x) { x.classList.remove("is-act"); });
        act = n; if (n >= 0) { opts[n].classList.add("is-act"); opts[n].scrollIntoView({ block: "nearest" }); }
      };
      var open = function () {
        if (openDd === d) return; closeDd(false);
        openDd = d; list.hidden = false; trig.setAttribute("aria-expanded", "true"); wrap.classList.add("is-open");
        setAct(Math.max(0, o.v.indexOf(val)));
      };
      trig.addEventListener("click", function (e) { e.stopPropagation(); if (openDd === d) closeDd(false); else open(); });
      trig.addEventListener("keydown", function (e) {
        var isOpen = openDd === d, n = act;
        if (e.key === "Escape") { if (isOpen) { e.preventDefault(); closeDd(true); } return; }
        if (e.key === "Tab") { closeDd(false); return; }
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
          e.preventDefault(); if (!isOpen) { open(); return; }
          var step = e.key === "ArrowDown" ? 1 : -1;
          do { n = Math.min(opts.length - 1, Math.max(0, n + step)); } while (opts[n].getAttribute("aria-disabled") === "true" && n > 0 && n < opts.length - 1);
          setAct(n); return;
        }
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (!isOpen) { open(); return; }
          if (act >= 0 && opts[act].getAttribute("aria-disabled") !== "true") opts[act].click(); else closeDd(true);
        }
      });
      return wrap;
    }
    choose(b, i, k, val) {
      var st = this.st, cur = this.byId[st.rows[b][i]]; if (!cur) return;
      var sel = cur.o.slice(); sel[k] = val;
      for (var j = k + 1; j < sel.length; j++) { var ok = this.allowed(sel, j); if (ok.indexOf(sel[j]) < 0) sel[j] = ok[0]; }
      var v = this.pick(sel); if (!v) { this.render(); return; }
      st.rows[b][i] = v.id;
      if (v.id !== st.main) this.followPicker(v);
      this.render(); fire(document, "et-bundle:change", { pid: this.pid });
    }
    // de gewone kleur- en maatkeuze bovenaan volgt het gekozen stuk (zoals Noirski); het thema doet de rest (foto, prijs, URL)
    followPicker(v) {
      var form = document.getElementById(this.dataset.form), last = null, st = this.st;
      if (!form) return;
      this.O.forEach(function (o, k) {
        var id = o.i[o.v.indexOf(v.o[k])];
        var inp = Array.prototype.find.call(document.querySelectorAll('input[data-option-position="' + (k + 1) + '"]'), function (x) { return x.form === form && String(x.value) === String(id); });
        if (inp && !inp.checked) { inp.checked = true; last = inp; }
      });
      if (!last) return;
      st.main = v.id; st.sent.push(v.id); if (st.sent.length > 6) st.sent.shift();
      last.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  // ── de vaste koopknop onderaan volgt de gekozen balk ──────────────────────────────────────────────────────────────────
  function bundleEl(pid) { return document.querySelector('et-bundle[data-pid="' + pid + '"]'); }
  function itemsFor(el) {
    var m = {}, order = [];
    el.st.rows[2].forEach(function (id) { if (!m[id]) { m[id] = 0; order.push(id); } m[id]++; });
    return order.map(function (id) { return { id: id, quantity: m[id] }; });
  }
  function syncSticky() {
    document.querySelectorAll("product-sticky-bar").forEach(function (bar) {
      var fid = bar.getAttribute("form"), m = FORM_RE.exec(fid || ""), el = m && bundleEl(m[1]);
      var btn = bar.querySelector("buy-buttons button[type=submit], buy-buttons .button");
      var two = !!(el && el.st && el.st.bar === 2);
      var info = bar.querySelector(".product-sticky-bar__info .v-stack");
      if (btn) {
        if (btn.dataset.etHtml == null) btn.dataset.etHtml = btn.innerHTML;
        if (two && !btn.disabled) btn.textContent = "Dodaj 2 szt. do koszyka"; else btn.innerHTML = btn.dataset.etHtml;
      }
      bar.classList.toggle("et-bn-on", two);
      if (info) {
        var old = info.querySelector(".et-sbn"); if (old) old.remove();
        if (two) {
          var t = totals(el.st.rows[2].map(function (id) { return el.byId[id]; }));
          var s = document.createElement("span"); s.className = "et-sbn";
          s.innerHTML = "<b></b><s></s>"; s.firstChild.textContent = fmt(t.pay); s.lastChild.textContent = fmt(t.was);
          info.appendChild(s);
        }
      }
    });
  }
  var queued = false;
  function later() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; syncSticky(); }); }
  document.addEventListener("et-bundle:change", later);
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches("product-rerender, product-sticky-bar") || n.querySelector("product-sticky-bar"))) { later(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ── toevoegen: balk 1 = het gewone formulier van het thema; balk 2 = twee regels in één verzoek ───────────────────────
  document.addEventListener("submit", function (e) {
    var form = e.target, m = form && FORM_RE.exec(form.getAttribute("id") || ""), el = m && bundleEl(m[1]);
    if (!el || !el.st || el.st.bar !== 2) return;
    e.preventDefault(); e.stopImmediatePropagation();
    add(form, el);
  }, true);

  async function add(form, el) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var buttons = Array.prototype.filter.call(form.elements, function (b) { return b.type === "submit"; });
    var all = Array.prototype.slice.call(document.querySelectorAll('button[type=submit][form="' + form.getAttribute("id") + '"]')).concat(buttons);
    if (all.some(function (b) { return b.getAttribute("aria-busy") === "true"; })) return;
    all.forEach(function (b) { b.setAttribute("aria-busy", "true"); });
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sections } }));
    var items = itemsFor(el);
    var res, body;
    try {
      res = await fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ items: items, sections: sections.join(","), sections_url: root + "variants/" + items[0].id }) });
      body = await res.json();
    } catch (err) { res = { ok: false }; body = { description: "Nie udało się dodać do koszyka. Spróbuj ponownie." }; }
    all.forEach(function (b) { b.removeAttribute("aria-busy"); });
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    var set = window.themeVariables && window.themeVariables.settings || {};
    if (res.ok) {
      if (set.cartType === "page" || set.pageType === "cart") { window.location.href = root + "cart"; return; }
      var cart = await (await fetch(root + "cart.js")).json();
      cart.sections = body.sections;
      form.dispatchEvent(new CustomEvent("variant:add", { bubbles: true, detail: { items: body.items || [body], cart: cart, onSuccessDo: null } }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "variant:add", onSuccessDo: null, cart: cart } }));
    } else {
      form.dispatchEvent(new CustomEvent("cart:error", { bubbles: true, detail: { error: body.description || body.message || "Nie udało się dodać do koszyka." } }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
  }
})();
